let selectedVoteId = null;

$(document).ready(function () {
/*Save the week, Goal ofthe round */

console.log('user_logged = ', user_logged);


    $('.vote-option-wrapper').on('click', function () {
        $('.vote-option-wrapper').removeClass('selected');
        $(this).addClass('selected');
        selectedVoteId = $(this).data('vote-id');
        checkVoteReadiness();
    });

    $('.goal-button').on('click', function () {
        if (!user_logged) {
            $('dialog#main-profile-menu')[0].showModal();
            return;
        }

        const moduleId = $(this).data('module-id');
        const url = '/gol-na-kruga/vote-' + moduleId + '-' + selectedVoteId;

        if (selectedVoteId) {
            $.ajax({
                url: url,
                method: 'POST',
                success: function(data) {
                    var resultObject = JSON.parse(data);
                    if (typeof resultObject.votes !== 'undefined' &&
                        typeof resultObject.moduleId !== 'undefined' &&
                        resultObject.votes !== false) {
                        updateGoalModuleResults(resultObject.moduleId, resultObject.votes)
                    }
                }
            });
        }
    });

    function checkVoteReadiness() {
        if (selectedVoteId) {
            $('.goal-button').removeClass('disabled');
        }
    }

    function updateGoalModuleResults(moduleId, votesPercent) {
        $('.vote-option-wrapper').removeClass('selected');
        $('[id="goal-module-' + moduleId + '"]').addClass('voted');
        $('.interaction-wrapper').removeClass('g-hidden');
        $('.goal-button').addClass('g-hidden');
        $('.ranking').removeClass('g-hidden');

        $('.vote-option-wrapper').each(function () {
            const voteId = $(this).data('vote-id');
            const percent = votesPercent[voteId] || 0;

            $(this).find('.percent').text(percent + ' %');
            $(this).find('.results .full').css('width', percent + '%');
        });

    }
});